import React, { useEffect, useState } from "react";
import { backend_url } from "../App";
import ReactPaginate from "react-paginate";
import "./CSS/Orders.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OrderDetails = () => {
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [activeTab, setActiveTab] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [editingOrder, setEditingOrder] = useState(null);
  const [viewOrder, setViewOrder] = useState(null);
  const ordersPerPage = 5;
  const [dateFilter, setDateFilter] = useState("");
  const [totalOrders, setTotalOrders] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [pendingOrders, setPendingOrders] = useState(0);
  const [completedOrders, setCompletedOrders] = useState(0);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    fetchOrderDetails();
  }, []); //
  useEffect(() => {
    // Move the stats calculation to a separate effect
    const filtered = orders.filter((order) =>
      dateFilter
        ? new Date(order.orderDate).toLocaleDateString("en-CA") === dateFilter
        : true
    );

    const total = filtered.length;
    const cost = filtered.reduce((sum, order) => sum + order.totalPrice, 0);
    const pending = filtered.filter(
      (order) =>
        order.status === "Pending" ||
        order.status === "Packed" ||
        order.status === "Shipped"
    ).length;
    const completed = filtered.filter(
      (order) => order.status === "Delivered"
    ).length;

    setTotalOrders(total);
    setTotalCost(cost);
    setPendingOrders(pending);
    setCompletedOrders(completed);
  }, [orders, dateFilter]);

  const fetchOrderDetails = async () => {
    try {
      const response = await fetch(`${backend_url}/allorders`, {
        method: "GET",
      });

      const data = await response.json();

      if (data.success) {
        setOrders(data.orders);

        const total = data.orders.length;
        const cost = data.orders.reduce(
          (sum, order) => sum + order.totalPrice,
          0
        );
        const pending = data.orders.filter(
          (order) => order.status === "Pending"
        ).length;
        const completed = data.orders.filter(
          (order) => order.status === "Completed"
        ).length;

        setTotalOrders(total);
        setTotalCost(cost);
        setPendingOrders(pending);
        setCompletedOrders(completed);
      } else {
        console.error("Failed to fetch order details:", data.message);
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
    }
  };

  // Fetch order details by ID
  const fetchOrderById = async (id) => {
    try {
      const response = await fetch(`${backend_url}/order/${id}`);
      const data = await response.json();

      if (data.success) {
        setViewOrder(data.order);
      } else {
        console.error("Failed to fetch order details:", data.message);
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
    }
  };

  // Filter orders based on tab
  const filteredOrders = orders.filter((order) => {
    if (activeTab === "All") return true;
    if (activeTab === "Progress")
      return ["Pending", "Confirmed", "Packed", "Shipped"].includes(
        order.status
      );
    if (activeTab === "Completed") return ["Delivered"].includes(order.status);
    if (activeTab === "Cancelled") return ["Cancelled"].includes(order.status);
    return true;
  });

  // Search within the filtered list
  // const searchedOrders = filteredOrders.filter(
  //   (order) =>
  //     order.productId?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //     order.userId?.name?.toLowerCase().includes(searchQuery.toLowerCase())
  // );

  // Search + Date Filter
  const searchedOrders = filteredOrders.filter((order) => {
    const matchSearch =
      order.productId?.name
        ?.toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      order.userId?.name?.toLowerCase().includes(searchQuery.toLowerCase());

    const matchDate = dateFilter
      ? new Date(order.orderDate).toLocaleDateString("en-CA") === dateFilter
      : true;

    return matchSearch && matchDate;
  });

  // Pagination
  const offset = currentPage * ordersPerPage;
  const currentOrders = searchedOrders.slice(offset, offset + ordersPerPage);
  const pageCount = Math.ceil(searchedOrders.length / ordersPerPage);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(0);
  };

  const handleViewDelivery = (order) => {
    setSelectedOrder(order);
  };

  const handleCloseModal = () => {
    setSelectedOrder(null);
  };

  // Handle edit
  const handleEdit = (order) => {
    setEditingOrder(order);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        `${backend_url}/edit-order/${editingOrder._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            size: "None",
            quantity: editingOrder.quantity,
            status: editingOrder.status,
          }),
        }
      );

      const data = await response.json();
      if (data.success) {
        toast.success("Order Status update successfully");
        // Refresh the orders list after updating
        fetchOrderDetails();
        setEditingOrder(null);
      } else {
        toast.error("Failed to update order:", data.message);
      }
    } catch (error) {
      toast.error("Error updating order:", error);
    }
  };
  return (
    <>
      <div className="order-details-container">
        {/* Header */}
        <div className="header-container">
          <h2 className="order-title">🛒 Order Details</h2>

          {/* Tabs */}
          <div className="tabs">
            {["All", "Progress", "Completed", "Cancelled"].map((tab) => (
              <button
                key={tab}
                className={`tab-button ${activeTab === tab ? "active" : ""}`}
                onClick={() => handleTabChange(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Search Bar */}
          {/* <div className="search-bar">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            placeholder="Search orders..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div> */}
          <div className="search-bar">
            <span className="search-icon">🔍</span>
            <input
              type="text"
              placeholder="Search orders..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />{" "}
            <br />
            <input
              type="date"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
              className="date-picker"
            />
          </div>

          {/* Date Picker */}
        </div>

        <div className="stats-container">
          <div className="stat-card">
            <h4>Total Orders</h4>
            <p>{totalOrders}</p>
          </div>
          <div className="stat-card">
            <h4>Total Cost</h4>
            <p>₹{totalCost.toFixed(2)}</p>
          </div>
          <div className="stat-card">
            <h4>Pending Orders</h4>
            <p>{pendingOrders}</p>
          </div>
          <div className="stat-card">
            <h4>Completed Orders</h4>
            <p>{completedOrders}</p>
          </div>
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Product</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Status</th>
                <th>Order Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentOrders.length > 0 ? (
                currentOrders.map((order) => (
                  <tr key={order._id}>
                    {/* Product with Image + Name */}
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <img
                          src={
                            order.productId?.images?.[0] || order.images?.[0]
                          }
                          alt={order.productId?.name}
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                        <span>
                          {order.productId?.unique_id || "N/A"} -{" "}
                          {order.productId?.name || "N/A"}
                        </span>
                      </div>
                    </td>

                    <td>{order.quantity}</td>
                    <td className="price">₹{order.totalPrice.toFixed(2)}</td>
                    <td>
                      <span
                        className={`status-badge ${
                          order.status === "Pending"
                            ? "pending"
                            : order.status === "Confirmed"
                            ? "confirmed"
                            : order.status === "Packed"
                            ? "packed"
                            : order.status === "Shipped"
                            ? "shipped"
                            : order.status === "Delivered"
                            ? "delivered"
                            : order.status === "Cancelled"
                            ? "cancelled"
                            : ""
                        }`}
                      >
                        {order.status}
                      </span>
                    </td>
                    <td>{new Date(order.orderDate).toLocaleDateString()}</td>

                    {/* Actions */}
                    <td>
                      {/* <div style={{ display: "flex", gap: "10px" }}>
                    <button onClick={() => handleEdit(order)} className="edit-button">
                      Edit
                    </button>
                    <button onClick={() => handleViewDelivery(order)} className="edit-button">
                      Delivery Details
                    </button>
                  </div> */}
                      <td>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <button
                            onClick={() => handleEdit(order)}
                            className="action-button edit-button"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleViewDelivery(order)}
                            className="action-button delivery-button"
                          >
                            Delivery Details
                          </button>
                        </div>
                      </td>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    style={{
                      textAlign: "center",
                      padding: "16px",
                      color: "#6b7280",
                    }}
                  >
                    No orders found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Delivery Info Modal */}
          {selectedOrder && (
           <div className="modal-overlay">
  <div className="modal-card">
    <h2 className="modal-title">Delivery Details</h2>

    <p className="modal-detail">
      <span className="modal-label">Name:</span> {selectedOrder.name}
    </p>

    <p className="modal-detail">
      <span className="modal-label">Email:</span> {selectedOrder.email}
    </p>

    <p className="modal-detail">
      <span className="modal-label">Phone:</span> {selectedOrder.phoneNumber}
    </p>

    <p className="modal-detail">
      <span className="modal-label">Address:</span> 
      {selectedOrder.address}, {selectedOrder.city}, {selectedOrder.state}, {selectedOrder.country} - {selectedOrder.pincode}
    </p>

    <button onClick={handleCloseModal} className="modal-close-btn">
      Close
    </button>
  </div>
</div>
          )}
        </div>

        {/* Pagination */}
        {searchedOrders.length > ordersPerPage && (
          <div className="pagination-wrapper">
            <ReactPaginate
              previousLabel="←"
              nextLabel="→"
              breakLabel="..."
              pageCount={pageCount}
              onPageChange={handlePageChange}
              containerClassName="pagination"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              activeClassName="active"
              disabledClassName="disabled"
            />
          </div>
        )}

        {viewOrder && (
          <div className="modal">
            <h3>Order Details</h3>
            <p>Product: {viewOrder.productId?.name}</p>
            <p>Size: {viewOrder.size}</p>
            <p>Quantity: {viewOrder.quantity}</p>
            <p>Status: {viewOrder.status}</p>
            <p>Price: ₹{viewOrder.totalPrice.toFixed(2)}</p>
            <button onClick={() => setViewOrder(null)}>Close</button>
          </div>
        )}

        {/* Edit Modal */}
        {editingOrder && (
          <div className="modal">
            <form onSubmit={handleEditSubmit}>
              <h3>Edit Order</h3>

              {/* Size */}
              {/* <div className="form-group">
                <label htmlFor="size">Size</label>
                <input
                  id="size"
                  type="text"
                  value={editingOrder.size}
                  onChange={(e) =>
                    setEditingOrder({ ...editingOrder, size: e.target.value })
                  }
                />
              </div> */}

              {/* Quantity */}
              <div className="form-group">
                <label htmlFor="quantity">Quantity</label>
                <input
                  id="quantity"
                  type="number"
                  disabled
                  value={editingOrder.quantity}
                  onChange={(e) =>
                    setEditingOrder({
                      ...editingOrder,
                      quantity: e.target.value,
                    })
                  }
                />
              </div>

              {/* Status */}
              <div className="form-group">
                <label htmlFor="status">Status</label>
                <select
                  id="status"
                  value={editingOrder.status}
                  onChange={(e) =>
                    setEditingOrder({ ...editingOrder, status: e.target.value })
                  }
                >
                  <option value="Pending">Pending</option>
                  <option value="Confirmed">Confirmed</option>
                  <option value="Packed">Packed</option>
                  <option value="Shipped">Shipped</option>
                  <option value="Delivered">Delivered</option>
                  <option value="Cancelled">Cancelled</option>
                </select>
              </div>

              {/* Buttons */}
              <div className="modal-buttons">
                <button type="submit" className="save-button">
                  Save
                </button>
                <button
                  type="button"
                  onClick={() => setEditingOrder(null)}
                  className="cancel-button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
      <ToastContainer />
    </>
  );
};

export default OrderDetails;
